module.exports = __webpack_public_path__ + "FFmerch.webp?0d14fa7bee3180cf72e591d673bef219";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/FFmerch.webp
// module id = 82
// module chunks = 0